export var REQUEST_REGISTRATION_NAME = 'cross-flow-product-request';
export var REQUEST_REGISTRATION_OWNER = 'Multipliers';
export var REQUEST_REGISTRATION_PRODUCT = 'cross-flow';
export var isRequestNotification = function isRequestNotification(notification) {
  return notification.analyticsAttributes.registrationName === REQUEST_REGISTRATION_NAME && notification.analyticsAttributes.registrationOwner === REQUEST_REGISTRATION_OWNER && notification.analyticsAttributes.registrationProduct === REQUEST_REGISTRATION_PRODUCT;
};